//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#CLASSIFICATION}\n\
 *\n\
 * @name czm_passClassification\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passClassification = 7.0;\n\
";
